<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">记录详情</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
    </el-row>
    <!-- 详情 -->
    <section class="xDetail">
      <p class="xDetail-title" v-show="condition.businesscode !='36'">{{condition.fundname}}</p>
      <!-- 金额，份额 -->
      <div v-show="condition.businesscode !='36'">
        <p class="xDetail-title1" v-show="condition.businesscode != '24' && condition.businesscode != '43' && condition.businesscode != '59' && condition.businesscode != '60' && condition.businesscode != '29'">{{publicDetail.applicationamount+'元'}}</p>
        <!-- 卖出 -->
        <p class="xDetail-title1" v-show="condition.businesscode == '24'">{{publicDetail.applicationvol+'份'}}</p>
        <!-- 分红 -->
        <p class="xDetail-title1" v-show="condition.businesscode == '43'">{{ publicDetail.confirmedvol+'元'}}</p>
        <p class="xDetail-title1" v-show="condition.businesscode == '59'">定期定额开通</p>
        <p class="xDetail-title1" v-show="condition.businesscode == '60'">定期定额撤销</p>
      </div>

      <!-- 转换 -->
      <div class="xDetail-switch margin-t15" v-show="condition.businesscode =='36'">
        <span class="xDetail-switch-fl">{{publicDetail.fundname}}</span>
        <div class="xDetail-switch-cen">转换为</div>
        <span class="xDetail-switch-fl">{{publicDetail.targetfundname}}</span>
      </div>
      <!-- 转换 -->
      <div class="xDetail-switch margin-t15" v-show="condition.businesscode == '29'">
        <span class="xDetail-switch-fl">{{beforedivmethod}}</span>
        <div class="xDetail-switch-cen">修改为</div>
        <span class="xDetail-switch-fl">{{afterdivmethod}}</span>
      </div>
      <!-- 提醒状态 -->
      <p class="xDetail-subtit-" v-show="condition.transstatus == '03' && condition.businesscode != '43' && condition.businesscode != '24'&& condition.businesscode != '29'">份额待确认</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus == '03' && condition.businesscode == '24'">金额待确认</p>
      <div v-show="condition.transstatus == '05' && condition.paytype == '2'">
        <p class="xDetail-subtit-">待支付</p>
        <p class="xDetail-subtit-"><span class="xDetail-ul-li">{{'请于'+condition.transactiondate.substr(4, 2) + "-"+condition.transactiondate.substr(6, 2)+ ' 15点前完成支付，15点以后交易将关闭'}}</span></p>
      </div>

      <!-- 现金分红 -->
      <p class="xDetail-subtit-" v-show="condition.businesscode =='43'">金额确认</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='00'">交易已撤单</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='07'">待勾兑</p>

      <p class="xDetail-subtit-" v-show="condition.transstatus =='01' && condition.businesscode == '22'">买入成功</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='01' && condition.businesscode == '36'">交易成功</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='01' && (condition.businesscode == '59' || condition.businesscode == '60')">确认成功</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='01' && condition.businesscode == '24'">卖出成功</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='01' && condition.businesscode == '39'">定投成功</p>

      <p class="xDetail-subtit-" v-show="condition.transstatus =='06'">交易关闭</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='04' || (condition.transstatus == '05' && condition.paytype == '1')">受理失败</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus =='02'">转换失败</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus == '03' && condition.businesscode == '29'">分红方式修改中</p>
      <p class="xDetail-subtit-" v-show="condition.transstatus == '01' && condition.businesscode == '29'">分红方式修改成功</p>
      <!-- 卖出 -->
      <ul class="xDetail-stepsone" v-show="condition.transstatus =='03' && condition.businesscode == '24'">
        <li class="xDetail-stepsone-li1">
          <div class="xDetail-stepsone-li1-head">
            <img src="../../../assets/images/time.png" alt="" width="20" height="20">
          </div>
          <div class="xDetail-stepsone-li1-main">{{publicDetail.expectcfmdate+'日'+publicDetail.expectcfmworkday+'卖出金额确认'}}</div>
        </li>
      </ul>
      <!-- 其他 -->
      <ul class="xDetail-stepsone" v-show="condition.transstatus =='03'&& condition.businesscode != '24'">
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/time.png" alt="" width="20" height="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">{{publicDetail.expectcfmdate+'日'+publicDetail.expectcfmworkday+'确认份额，开始计算收益'}}</div>
        </li>
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/20210316_sy.png" alt="" width="20" height="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">{{publicDetail.expectpftdate+'日'+publicDetail.expectpftworkday+'查看收益'}}</div>
        </li>
      </ul>
      <ul class="xDetail-ul margin-t20" v-show="condition.transstatus =='02' || condition.transstatus =='06'">
        <li class="xDetail-ul-li" v-show="condition.transstatus =='02'"><span>失败原因：</span><span>{{publicDetail.returnmsg}}</span></li>
        <li class="xDetail-ul-li" v-show="condition.transstatus =='06'"><span>失败原因：</span><span>订单超时未支付</span></li>
      </ul>
      <hr class="xDetail-hr">
      <!-- 买入 -->
      <div v-show="condition.businesscode == '22' || condition.businesscode == '20'">
        <p class="xDetail-subtit1">买入申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>买入金额：</span><span>{{publicDetail.applicationamount + '元'}}</span></li>
          <li class="xDetail-ul-li" v-show="publicDetail.moneyasset != publicDetail.applicationamount"><span>优惠减扣：</span><span>{{parseFloat(publicDetail.applicationamount - publicDetail.moneyasset).toFixed(2)+ '元'}}</span></li>
          <li class="xDetail-ul-li" v-show="publicDetail.moneyasset != publicDetail.applicationamount"><span>实付金额：</span><span>{{publicDetail.moneyasset+ '元'}}</span></li>
          <li class="xDetail-ul-li"><span>付款方式：</span><span>{{condition.account}}</span></li>
          <li class="xDetail-ul-li"><span>买入时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 卖出 -->
      <div v-show="condition.businesscode == '24'">
        <p class="xDetail-subtit1">卖出申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>卖出份额：</span><span>{{publicDetail.applicationvol+'份'}}</span></li>
          <li class="xDetail-ul-li"><span>到账方式：</span><span>{{condition.account}}</span></li>
          <li class="xDetail-ul-li"><span>卖出时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 定投 -->
      <div v-show="condition.businesscode == '39' || condition.businesscode == '59' || condition.businesscode == '60' ">
        <p class="xDetail-subtit1">定投申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>定投金额：</span><span>{{publicDetail.applicationamount + '元'}}</span></li>
          <li class="xDetail-ul-li"><span>付款方式：</span><span>{{condition.account}}</span></li>
          <li class="xDetail-ul-li"><span>买入时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 分红 -->
      <div v-show="condition.businesscode == '43'">
        <p class="xDetail-subtit1">分红信息</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>分红方式：</span><span>{{publicDetail.defdividendmethod == '0'? '红利再投':'现金分红'}}</span></li>
          <li class="xDetail-ul-li"><span>分红所得：</span><span>{{publicDetail.confirmedvol + (publicDetail.defdividendmethod == '0'? '份':'元')}}</span></li>
          <li class="xDetail-ul-li"><span>分红日期：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 转换 -->
      <div v-show="condition.businesscode == '36' || condition.businesscode == '37' || condition.businesscode == '38'">
        <p class="xDetail-subtit1">转换申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>转换基金：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>转入基金：</span><span>{{publicDetail.targetfundname}}</span></li>
          <li class="xDetail-ul-li"><span>转出份额：</span><span>{{publicDetail.applicationvol + '份'}}</span></li>
          <li class="xDetail-ul-li"><span>申请时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 转托管 -->
      <div v-show="condition.businesscode == '26'">
        <p class="xDetail-subtit1">转托管申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>定投金额：</span><span>{{publicDetail.applicationvol+ '份'}}</span></li>
          <li class="xDetail-ul-li"><span>付款方式：</span><span>{{condition.account}}</span></li>
          <li class="xDetail-ul-li"><span>申请时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <!-- 其他 分红方式 -->
      <div v-show="condition.businesscode == '29'">
        <p class="xDetail-subtit1">设置分红方式申请</p>
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>基金名称：</span><span>{{publicDetail.fundname}}</span></li>
          <li class="xDetail-ul-li"><span>修改时间：</span><span>{{condition.time}}</span></li>
        </ul>
      </div>
      <hr class="xDetail-hr">
      <!-- 确认 -->
      <div v-show="(condition.transstatus =='01' && condition.businesscode != '43' ) || (condition.transstatus =='02' &&  condition.businesscode == '36')">
        <!-- 普通确认 -->
        <div v-show=" condition.businesscode != '36' &&  condition.businesscode != '59'&&  condition.businesscode != '60' &&condition.businesscode != '29'">
          <p class="xDetail-subtit1" v-show="condition.businesscode == '22'">买入确认</p>
          <p class="xDetail-subtit1" v-show="condition.businesscode == '24'">卖出确认</p>
          <p class="xDetail-subtit1" v-show="condition.businesscode == '39'">确认信息</p>
          <ul class="xDetail-ul">
            <li class="xDetail-ul-li"><span>确认金额：</span><span>{{publicDetail.confirmedamount + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>确认份额：</span><span>{{publicDetail.confirmedvol +'份'}}</span></li>
            <li class="xDetail-ul-li"><span>确认日期：</span><span>{{this.$commonJs.getDateStrHg(publicDetail.transactioncfmdate)}}</span></li>
            <li class="xDetail-ul-li"><span>确认净值：</span><span>{{publicDetail.nav + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>手续费：</span><span>{{publicDetail.charge + '元'}}</span></li>
          </ul>
        </div>

        <!-- 转换确认 -->
        <div v-show="condition.businesscode == '36' || condition.businesscode == '37' || condition.businesscode == '38'">
          <p class="xDetail-subtit1">转换确认</p>
          <ul class="xDetail-ul">
            <li class="xDetail-ul-li"><span>确认转出份额：</span><span>{{publicDetail.confirmedvol + '份'}}</span></li>
            <li class="xDetail-ul-li"><span>确认转出金额：</span><span>{{publicDetail.confirmedamount + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>确认转入份额：</span><span>{{publicDetail.cfmvoloftargetfund + '份'}}</span></li>
            <li class="xDetail-ul-li"><span>确认转入金额：</span><span>{{publicDetail.confirmedamount + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>转出确认净值：</span><span>{{publicDetail.nav + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>转入确认净值：</span><span>{{publicDetail.targetnav + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>手续费：</span><span>{{publicDetail.charge + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>确认日期：</span><span>{{this.$commonJs.getDateStrHg(publicDetail.transactioncfmdate)}}</span></li>
          </ul>
        </div>
        <!-- 其他确认 -->
        <div v-show="condition.businesscode == '26' ||  condition.businesscode == '59' ||  condition.businesscode == '60'">
          <p class="xDetail-subtit1"> {{condition.businesscode == '59'? '定投协议开通确认':'定投协议撤销确认' }}</p>
          <ul class="xDetail-ul">
            <li class="xDetail-ul-li"><span>确认金额：</span><span>{{publicDetail.confirmedamount + '元'}}</span></li>
            <li class="xDetail-ul-li"><span>确认日期：</span><span>{{this.$commonJs.getDateStrHg(publicDetail.transactioncfmdate)}}</span></li>
          </ul>
        </div>
        <!-- 其他 分红确认 -->
        <div v-show="condition.businesscode == '29'">
          <p class="xDetail-subtit1">设置分红方式确认</p>
          <ul class="xDetail-ul">
            <li class="xDetail-ul-li"><span>确认日期：</span><span>{{this.$commonJs.getDateStrHg(publicDetail.transactioncfmdate)}}</span></li>
          </ul>
        </div>
        <hr class="xDetail-hr">
      </div>

      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>订单编号</span><span>{{condition.businesscode == '43'? condition.taserialno:condition.appsheetserialno}}</span></li>
      </ul>
      <div class="xDetail-footer" v-if="canaleFlag && (condition.transstatus == '03'|| (condition.transstatus == '05' && condition.paytype == '2'))">
        <!-- 撤单 -->
        <el-button type="normal" @click="canceldialogVisable = true">撤单</el-button>
        <!-- 汇款 -->
        <el-button type="normal" v-if="canaleFlag && condition.transstatus == '05' && condition.paytype == '2'" @click="paydialogVisable = true">继续支付</el-button>
        <!-- 支付 -->
        <!-- <el-button type="normal" v-else-if="canaleFlag && condition.transstatus == '05' && condition.paytype == '1'" @click="payBankdialogVisable = true">继续支付</el-button> -->
      </div>
      <div class="xDetail-footer" v-else>
        <el-button type="back" @click="returnClick">返回</el-button>
      </div>

    </section>
    <!--撤单弹框 -->
    <el-dialog class="dialog-single-three" :visible.sync="canceldialogVisable" :close-on-click-modal="false" :before-close="cancelReturn">
      <div class="dialog-single-three-p">请输入支付密码</div>
      <el-form :model="cancelForm" ref="cancelFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="cancelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input v-model="cancelForm.pass" type="password" autocomplete="new-password" @blur="passBlur('cancel')" show-password></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="normal1" @click="canaleOrderClick">确定</el-button>
        <el-button type="cancel" style="width:154px" @click="cancelReturn">返回</el-button>
      </div>
    </el-dialog>
    <!-- 继续支付 汇款-->
    <el-dialog class="dialog-single-three" :visible.sync="paydialogVisable" :close-on-click-modal="false">
      <div style="font-size:18px;">该订单是汇款订单，点击确定查看汇款信息和交易说明，请尽快完成支付。</div>
      <div class="margin-t35" style="text-align:center;">
        <el-button type="normal1" @click="remittance">确定</el-button>
      </div>
    </el-dialog>
    <!-- 继续支付 银行卡 -->
    <el-dialog class="dialog-single-three" :visible.sync="payBankdialogVisable" :close-on-click-modal="false" :before-close="payReturn">
      <div class="dialog-single-three-p">请输入支付密码</div>
      <el-form :model="payForm" ref="payFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="payForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input v-model="payForm.pass" type="password" autocomplete="new-password" @blur="passBlur('pay')" show-password></el-input>
          <span class="dialog-single-three-error">{{payErrorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="normal1" @click="payFund">{{payFundText}}</el-button>
        <el-button type="cancel" style="width:154px" @click="payReturn">返回</el-button>
      </div>
    </el-dialog>
    <!-- 签约新渠道 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable1" :show-close="false" :close-on-click-modal="false">
      <div class="dialog-single-three-p">购买成功</div>
      <p class="instruction-li-con margin-t20">您可签约新支付渠道，新渠道单笔单日限额较当前渠道有大幅提升。也可稍后在【我的】-【账户管理】-【银行卡管理】自主签约。</p>
      <div class="margin-t20">
        <el-button type="back" style="width:154px;" @click="$router.push({ name: 'publicRecord' })">暂不签约</el-button>
        <el-button type="normal" style="width:154px;" @click="notHfSigned">签约新渠道</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      condition: '',//判断条件
      publicDetail: '',//详情
      // 转换
      beforedivmethod: '',
      afterdivmethod: '',
      // 撤单
      canceldialogVisable: false,
      errorMessage: '',
      errorShow: false,
      cancelForm: {
        name: '',
        pass: ''
      },
      canaleFlag: false,
      paydialogVisable: false,
      // 继续支付
      payBankdialogVisable: false,
      fundMessage: '',//单支基金信息
      payForm: {
        name: '',
        pass: ''
      },
      payErrorMessage: '',
      payFundText: '确定',
      dialogVisable1: false,
      time: '',//定时器
    }
  },
  created () {
    this.condition = this.$route.params.message
    this.publicDetail = this.$route.params.detail
    this.getOrderDetails()
    // console.log(this.condition, this.publicDetail);
    // 撤单判断
    const oldtime = this.$commonJs.getDateStrHg(this.condition.transactiondate) + ' 15:00:00'
    const nowtime = this.$commonJs.timeFormat(new Date())
    if (this.$commonJs.tab(oldtime, nowtime) == "1") {//可撤单
      this.canaleFlag = true
    } else {
      this.canaleFlag = false
    }
    // console.log(this.$commonJs.tab(oldtime, nowtime), this.canaleFlag);

    if (this.publicDetail.defdividendmethod == "0") {
      this.beforedivmethod = '现金分红';
      this.afterdivmethod = '红利再投';
    } else {
      this.beforedivmethod = '红利再投';
      this.afterdivmethod = '现金分红';
    }
  },
  methods: {
    returnClick () {
      if (this.$route.params.singleFlag == null) {
        this.$router.push({ name: 'publicRecord' })
      } else {
        this.$router.push({
          name: 'fundHoldDetails',
          params: {
            message: this.$route.params.singleMessage
          }
        })
      }
    },
    // 撤单
    canaleOrderClick () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
        var inputpwd = this.$des.enString(this.cancelForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        var reallypass = this.$commonJs.getCookie('Password')
        if (inputpwd != reallypass) {
          this.errorShow = true
          this.errorMessage = "密码输入错误"
        } else {
          this.errorShow = false
          this.errorMessage = ""
          this.$http.post(this.$apiPath.deleteTradesnew, {
            sessionId: this.$commonJs.getCookie('sessionid'),
            originalappsheetno: this.publicDetail.appsheetserialno,
            isDividends: this.condition.businesscode == '29' ? 1 : '',
            appnew: '1'
          }).then(res => {
            // console.log(res);
            if (res.status !== 200) return
            if (res.data.code == "200" && res.data.success) {
              this.$message.success('撤销成功')
              this.$router.push({
                name: 'publicRecord'
              })
              if (this.condition.businesscode == '22') {//买入
                // 推送消息
                this.$store.dispatch({
                  type: "pushNews",
                  index: this.condition.account.indexOf('银行') != -1 ? 2 : 6,
                  fundname: this.publicDetail.fundname,
                  money: this.publicDetail.applicationamount,
                  dtDate: "",
                  fundname2: ""
                })
              } else if (this.condition.businesscode == '24') {//卖出
                // 推送消息
                this.$store.dispatch({
                  type: "pushNews",
                  index: this.condition.account.indexOf('银行') != -1 ? 4 : 8,
                  fundname: this.publicDetail.fundname,
                  money: this.publicDetail.applicationvol,
                  dtDate: "",
                  fundname2: ""
                })
              } else if (this.condition.businesscode == '36' || this.condition.businesscode == '37' || this.condition.businesscode == '38') {
                // 推送消息
                this.$store.dispatch({
                  type: "pushNews",
                  index: 13,
                  fundname: this.publicDetail.fundname,
                  money: this.publicDetail.applicationvol,
                  dtDate: "",
                  fundname2: this.publicDetail.targetfundname
                })
              }

            } else if (res.data.code == "9999") {
              this.$message.error(res.data.message)
              this.canceldialogVisable = false
            } else if (res.data.code == "2003") {
              this.$message.error('不允许跨基金交易日撤单，撤单失败')
              this.canceldialogVisable = false
            } else {
              this.$message.error(res.data.message)
              this.canceldialogVisable = false
            }
          }).catch(err => { })
        }
      }
    },
    cancelReturn () {
      this.canceldialogVisable = false
      this.$refs.cancelFormRef.resetFields()
    },
    // 密码失去焦点
    passBlur (val) {
      if (val == 'cancel') {
        this.errorShow = this.cancelForm.pass.trim() == "" ? true : false
        this.errorMessage = this.cancelForm.pass.trim() == "" ? '请输入密码' : ''
      } else if (val == 'pay') {
        this.payErrorMessage = this.payForm.pass.trim() == "" ? '请输入密码' : ''
      }
    },
    // 汇款说明
    remittance () {
      this.$router.push({
        name: 'remitMoneySuccess',
        params: {
          card: this.condition.channelid,
          name: 'publicRecord',
          message: this.condition,
          money: this.publicDetail.applicationamount
        }
      })
    },
    // 支付返回，取消
    payReturn () {
      this.payBankdialogVisable = false
      this.$refs.payFormRef.resetFields()
      this.payErrorMessage = ''
    },
    // 支付
    payFund () {
      // console.log(this.condition);
      this.payFundText = '确定中...'
      let pass = this.$des.enString(this.payForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      if (this.payForm.pass.trim() == '') {
        this.payErrorMessage = '请输入密码'
        this.payFundText = '确定'
      } else if (pass != this.$commonJs.getCookie('Password')) {
        this.payErrorMessage = '密码输入错误'
        this.payFundText = '确定'
      } else {
        this.getHfPay()
      }
    },
    // 富友支付(不用删掉)
    getPay () {
      this.$http.post(this.$apiPath.readyPayStepnew, {
        appsheetserialno: this.condition.appsheetserialno,
        fundcode: this.fundMessage.fundcode,//
        tano: this.fundMessage.tano,//
        channelid: this.fundMessage.channelid,
        moneyaccount: this.fundMessage.moneyaccount,
        appuuid: "",
        fundtype: this.fundMessage.fundtype,
        deviceId: "",
        applicationamount: this.fundMessage.applicationamount,//申请金额（不是实付）
        fundstatus: this.fundMessage.status == 1 ? 20 : 22,//
        sessionId: this.$commonJs.getCookie('sessionid'),
        passwd: this.$des.enString(this.payForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        fundname: this.condition.fundname,
        liqdate: this.fundMessage.operdate,
        appnew: 1,//新个人中心标志
      }).then(res => {
        if (res.status !== 200) return
        // console.log(res);
        if (res.data.code == "200") {
          if (res.data.data.code == "0000" && res.data.data.forward == "socketPay") {//成功
            this.payErrorMessage = ''
            this.$message.success('购买成功')
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 1,
              fundname: this.condition.fundname,
              money: this.fundMessage.applicationamount,
              dtDate: "",
              fundname2: ""
            })
            this.payBankdialogVisable = false
            this.dialogVisable1 = true
          } else if (res.data.data.readyPayMsg.code == "100085" || res.data.data.readyPayMsg.code == "100086" || res.data.data.readyPayMsg.msg == "尚未进行快捷签约") {
            this.$message.error('您的银行卡未签约，请先进行验卡，在进行支付')
            // 未签约
            this.notHfSigned()
          } else if (res.data.data.code == "-990016001") {
            if (res.data.data.msg == "余额不足") {
              this.payErrorMessage = "扣款失败，请检查银行卡余额！"
            } else if (res.data.data.msg == "单笔金额超限") {
              this.payErrorMessage = "单笔金额超限！"
            } else {
              this.payErrorMessage = res.data.data.msg
            }
            this.payFundText = '确定'
          } else {
            this.payErrorMessage = res.data.data.readyPayMsg ? res.data.data.readyPayMsg.msg : res.data.message
            this.payFundText = '确定'
          }
        } else {
          this.payErrorMessage = res.data.data.readyPayMsg ? res.data.data.readyPayMsg.msg : res.data.message
          this.payFundText = '确定'
        }
      }).catch(err => { })
    },
    // 汇付支付
    getHfPay () {
      this.$http.post(this.$apiPath.readyPay, {
        fundtype: this.fundMessage.fundtype,
        fundcode: this.fundMessage.fundcode,//
        fundname: this.condition.fundname,
        sessionId: this.$commonJs.getCookie('sessionid'),
        deviceId: "",
        appsheetserialno: this.condition.appsheetserialno,
        moneyaccount: this.fundMessage.moneyaccount,
        applicationamount: this.fundMessage.applicationamount,//申请金额（不是实付）
        passwd: this.$des.enString(this.payForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        liqdate: this.fundMessage.transactiondate,
        tano: this.fundMessage.tano,
        channelid: this.fundMessage.channelid,
        paycenterid: this.fundMessage.paycenterid,
        fundstatus: this.fundMessage.status == 1 ? 20 : 22,
        appnew: 1,//新个人中心标志
        // 旧
        // appsheetserialno: this.condition.appsheetserialno,
        // fundcode: this.fundMessage.fundcode,//
        // fundtype: this.fundMessage.fundtype,
        // tano: this.fundMessage.tano,//
        // channelid: this.fundMessage.channelid,
        // moneyaccount: this.fundMessage.moneyaccount,
        // deviceId: "",
        // applicationamount: this.fundMessage.applicationamount,//申请金额（不是实付）
        // fundstatus: this.fundMessage.status == 1 ? 20 : 22,//
        // sessionId: this.$commonJs.getCookie('sessionid'),
        // fundname: this.condition.fundname,
        // liqdate: this.fundMessage.transactiondate,
        // appnew: 1,//新个人中心标志
      }).then(res => {
        if (res.status !== 200) return
        // console.log(res);
        if (res.data.code == "FS9") {//汇付成功
          this.getHfResult()
        } else if (res.data.code == "200") {//富友成功；用优惠券实付金额为0 成功
          this.payErrorMessage = ''
          this.$message.success('购买成功')
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 1,
            fundname: this.condition.fundname,
            money: this.fundMessage.applicationamount,
            dtDate: "",
            fundname2: ""
          })
          this.$router.push({ name: 'publicRecord' })
        } else if (res.data.code == "2222") {//重新签约
          this.notHfSigned()
        } else {
          this.payErrorMessage = res.data.message
          this.payFundText = '确定'
        }
      }).catch(err => { })
    },
    // 汇付查询结果
    getHfResult () {
      this.$http.post(this.$apiPath.hfquery, {
        appsheetserialno: this.condition.appsheetserialno
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {//成功
          this.payErrorMessage = ''
          this.$message.success('购买成功')
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 1,
            fundname: this.condition.fundname,
            money: this.fundMessage.applicationamount,
            dtDate: "",
            fundname2: ""
          })
          clearInterval(this.time)
          this.$router.push({ name: 'publicRecord' })
        } else if (res.data.code == "FS9") {//支付结果查询中
          this.time = setInterval(() => {
            this.getHfResult()
          }, 2000);
        } else {
          this.payErrorMessage = res.data.message
          this.payFundText = '确定'
          this.$message.error(res.data.message)
          clearInterval(this.time)
          this.$router.push({ name: 'publicRecord' })
        }
      }).catch(err => { })
    },
    // 未签约
    notHfSigned () {
      this.$router.push({
        name: 'bankCardVerificationHf',
        params: {
          name: 'publicRecord',
          cardMessage: {//银行卡信息
            depositacct: this.condition.depositacct,
            moneyaccount: this.fundMessage.moneyaccount,
            paycenterid: this.fundMessage.paycenterid,
            channelid: this.fundMessage.channelid,
          }
        }
      })
    },
    // 获取订单详情
    getOrderDetails () {
      this.$http.post(this.$apiPath.qeryBuyInfoBySheetNo, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: this.condition.appsheetserialno
      }).then(res => {
        if (res.data.data.publicRecord.length > 0) {
          this.fundMessage = res.data.data.publicRecord[0]
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
// 弹框
.detailName {
  font-size: 20px;
  font-weight: bold;
  color: #246ead;
  text-align: center;
  margin-top: 44px;
}
</style>